<template>
<!-- eslint-disable max-len -->
<span>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <media-zone
      v-if="narrative && useMediaZoneForNarrative && !hideMediaZone"
      :videos="narrative.videos"
      :images="narrative.images"
      :should-display-label="narrative.shouldDisplayMediaZoneLabel"
      :style="mediaZoneStyle"
    />
  </transition>
  <narrative-animation v-if="['animation'].includes(narrativeType)" key="animation" @input="updateNarrative"></narrative-animation>
  <narrative-exposition v-if="['exposition'].includes(narrativeType)" key="exposition" @input="updateNarrative"></narrative-exposition>
  <narrative-decision v-else-if="['leftDecision', 'rightDecision'].includes(narrativeType)" key="decision" @input="updateNarrative" :decision="individualDecision"></narrative-decision>
  <narrative-decision-bubble v-else-if="['leftDecisionBubble', 'rightDecisionBubble'].includes(narrativeType)" key="decisionBubble" @input="updateNarrative" :decision="individualDecision"></narrative-decision-bubble>
  <narrative-dialog v-else-if="['dialog'].includes(narrativeType)" key="dialog" @input="updateNarrative"></narrative-dialog>
  <narrative-location v-else-if="['enterLocation', 'exitLocation'].includes(narrativeType)" key="location" @input="updateNarrative"></narrative-location>
  <narrative-team v-else-if="narrativeType === 'team'" key="team" @input="updateNarrative"></narrative-team>
  <narrative-video v-else-if="['leftVideo', 'rightVideo'].includes(narrativeType)" key="video" @input="updateNarrative"></narrative-video>
  <narrative-video-full v-else-if="['fullVideo'].includes(narrativeType)" key="fullVideo" @input="updateNarrative"></narrative-video-full>
  <narrative-leadership-report v-else-if="['leadershipReport'].includes(narrativeType)" key="leadershipReport" @input="updateNarrative"></narrative-leadership-report>
  <narrative-leadership-report-legacy v-else-if="['leadershipReportLegacy','leadershipReportSF1.0'].includes(narrativeType)" key="leadershipReportLegacy" @input="updateNarrative"></narrative-leadership-report-legacy>
  <narrative-entrepreneurship-readiness-report v-else-if="['entrepreneurshipReadinessReport'].includes(narrativeType)" key="entrepreneurshipReadinessReport" @input="updateNarrative"></narrative-entrepreneurship-readiness-report>
  <narrative-student-report-a-d-t v-else-if="['studentReportADT'].includes(narrativeType)" key="studentReportADT" @input="updateNarrative"></narrative-student-report-a-d-t>
  <narrative-student-report-a-l-g v-else-if="['studentReportALG'].includes(narrativeType)" key="studentReportALG" @input="updateNarrative"></narrative-student-report-a-l-g>
  <narrative-student-report-h-s-g v-else-if="['studentReportHSG','studentReport'].includes(narrativeType)" key="studentReportHSG" @input="updateNarrative"></narrative-student-report-h-s-g>
  <narrative-corp-report-h-s-g v-else-if="['corpReportHSG'].includes(narrativeType)" key="corpReportHSG" @input="updateNarrative"></narrative-corp-report-h-s-g>
  <narrative-almas-report v-else-if="['almasReport'].includes(narrativeType)" key="almasReport" @input="updateNarrative"></narrative-almas-report>
  <narrative-almas-2-report v-else-if="['almas2Report'].includes(narrativeType)" key="almas2Report" @input="updateNarrative"></narrative-almas-2-report>
  <narrative-deloitte-report v-else-if="['deloitteReport'].includes(narrativeType)" key="deloitteReport" @input="updateNarrative"></narrative-deloitte-report>
  <narrative-report-h-p-g v-else-if="['reportHPG'].includes(narrativeType)" key="reportHPG" @input="updateNarrative"></narrative-report-h-p-g>
  <narrative-report-h-p-g-s v-else-if="['reportHPGS'].includes(narrativeType)" key="reportHPGS" @input="updateNarrative"></narrative-report-h-p-g-s>
  <narrative-report-c-m-f-c-2 v-else-if="['reportCMFC2'].includes(narrativeType)" key="reportCMFC2" @input="updateNarrative"></narrative-report-c-m-f-c-2>
  <narrative-report-decisions v-else-if="['reportDecisions'].includes(narrativeType)" key="reportDecisions" @input="updateNarrative"></narrative-report-decisions>
  <narrative-report-s-g-m v-else-if="['reportSGM'].includes(narrativeType)" key="reportSGM" @input="updateNarrative"></narrative-report-s-g-m>
  <narrative-certificate-p-h-n v-else-if="['certificatePHN'].includes(narrativeType)" key="certificatePHN" @input="updateNarrative"></narrative-certificate-p-h-n>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import NarrativeAnimation from './NarrativeAnimation';
import NarrativeExposition from './NarrativeExposition';
import NarrativeDecision from './NarrativeDecision';
import NarrativeDecisionBubble from './NarrativeDecisionBubble';
import NarrativeDialog from './NarrativeDialog';
import NarrativeLocation from './NarrativeLocation';
import NarrativeTeam from './NarrativeTeam';
import NarrativeVideo from './NarrativeVideo';
import NarrativeVideoFull from './NarrativeVideoFull';
import NarrativeLeadershipReport from './NarrativeLeadershipReport';
import NarrativeLeadershipReportLegacy from './NarrativeLeadershipReportLegacy';
import NarrativeEntrepreneurshipReadinessReport from './NarrativeEntrepreneurshipReadinessReport';
import NarrativeStudentReportADT from './NarrativeStudentReportADT';
import NarrativeStudentReportALG from './NarrativeStudentReportALG';
import NarrativeStudentReportHSG from './NarrativeStudentReportHSG';
import NarrativeCorpReportHSG from './NarrativeCorpReportHSG';
import NarrativeAlmasReport from './NarrativeAlmasReport';
import NarrativeAlmas2Report from './NarrativeAlmas2Report';
import NarrativeDeloitteReport from './NarrativeDeloitteReport';
import NarrativeReportHPG from './NarrativeReportHPG';
import NarrativeReportHPGS from './NarrativeReportHPGS';
import NarrativeReportCMFC2 from './NarrativeReportCMFC2';
import NarrativeReportDecisions from './NarrativeReportDecisions';
import NarrativeReportSGM from './NarrativeReportSGM';
import NarrativeCertificatePHN from './NarrativeCertificatePHN';
import MediaZone from '../ui/MediaZone';

export default {
  props: {
    individualDecision: { type: Object, default: () => ({}) },
    // use if no individualDecision
    narratives: { type: Array, default: () => [] },
    // use for completion when no decision
    onComplete: { type: Function }
  },
  components: {
    NarrativeAnimation,
    NarrativeDecision,
    NarrativeDecisionBubble,
    NarrativeDialog,
    NarrativeExposition,
    NarrativeLocation,
    NarrativeTeam,
    NarrativeVideo,
    NarrativeVideoFull,
    NarrativeLeadershipReport,
    NarrativeLeadershipReportLegacy,
    NarrativeStudentReportADT,
    NarrativeStudentReportALG,
    NarrativeStudentReportHSG,
    NarrativeCorpReportHSG,
    NarrativeEntrepreneurshipReadinessReport,
    NarrativeAlmasReport,
    NarrativeAlmas2Report,
    NarrativeDeloitteReport,
    NarrativeReportHPG,
    NarrativeReportHPGS,
    NarrativeReportCMFC2,
    NarrativeReportDecisions,
    NarrativeReportSGM,
    NarrativeCertificatePHN,
    MediaZone,
  },
  data() {
    return {
      hideMediaZone: false,
    };
  },
  computed: {
    ...mapGetters([
      'game',
      'narrativeIndex',
      'tooltip',
      'dashboardState',
      'narrative',
      'individualDecisionFromLastTeamDecision',
      'finalTeamDecisionComplete',
      'useMediaZoneForNarrative',
    ]),
    mediaZoneStyle() {
      let useLeft = !(this.game.narrativeMediaZonePositionXFromRight);
      const style = {
        position: 'absolute',
        bottom: this.game.narrativeMediaZonePositionY || '360px',
        left: useLeft ? (this.game.narrativeMediaZonePositionX || '640px') : 'unset',
        right: !useLeft ? (this.game.narrativeMediaZonePositionX || '640px') : 'unset',
        width: this.game.narrativeMediaZoneWidth || '960px',
        height: this.game.narrativeMediaZoneHeight || '540px',
      };
      if (this.narrative.mediaZoneOverride) {
        useLeft = !(this.narrative.mediaZonePositionXFromRight);
        style.bottom = this.narrative.mediaZonePositionY || style.bottom;
        style.left = useLeft ? (this.narrative.mediaZonePositionX || style.left) : 'unset';
        style.right = !useLeft ? (this.narrative.mediaZonePositionX || style.right) : 'unset';
        style.width = this.narrative.mediaZoneWidth || style.width;
        style.height = this.narrative.mediaZoneHeight || style.height;
      }
      return style;
    },
    narrativeType() {
      return this.narrative && this.narrative.type || '';
    }
  },
  methods: {
    ...mapActions([
      'setNarratives',
      'addNarratives',
      'advanceNarrative',
      'rewindNarrative',
      'advanceTooltip',
      'saveLastBackground',
      'saveBackgroundAudio',
      'stopSounds',
    ]),
    async updateNarrative(back = false) {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        console.log('tooltipclick');
        window.dispatchEvent(new Event('click'));
        return;
      }

      const mediaZoneHasContent = this.narrative && this.game.narrativeUsesMediaZone
        && ((this.narrative.videos && this.narrative.videos.length > 0)
          || (this.narrative.images && this.narrative.images.length > 0));
      this.hideMediaZone = true;
      if (mediaZoneHasContent) {
        await new Promise(resolve => setTimeout(resolve, 350));
      }

      await Vue.nextTick();

      if (back) {
        this.rewindNarrative();
      } else {
        this.advanceNarrative();
      }

      await Vue.nextTick();

      if (this.narrativeIndex === 0 && this.narrative && this.narrative.carryoverBackground) {
        // console.log('saveLastBackground');
        this.saveLastBackground();
      }

      if (this.narrative
        && (this.narrative.backgroundAudioChange
          || (this.narrative.backgroundAudioChange && this.narrative.backgroundAudioLoopingChange != null)
          || this.narrative.backgroundAudioVolumeChange
        )
      ) {
        this.saveBackgroundAudio();
      }

      if (this.narrative) {
        this.hideMediaZone = false;
        this.advanceTooltip();
      } else {
        await this.exit();
      }
    },
    async resetNarrativePlayer() {
      const { narratives } = this.individualDecision;
      this.addNarratives({ narratives });
    },
    async exit() {
      if (!this.onComplete) return this.$router.push(this.dashboardState);

      for (let i = 3; i > 0; --i) {
        try {
          return await this.onComplete();
        } catch (err) {
          if (this.$router.handleGameError(err)) return;
        }
      }

      this.$router.showGameErrorCritical();
    },
    init() {
      const narratives = this.individualDecision.narratives || this.narratives;
      this.setNarratives({ narratives });
      if (narratives.length) {
        this.updateNarrative(this.narrativeIndex > 0);
      } else {
        this.exit();
      }
    }
  },
  watch: {
    individualDecision(newValue, oldValue) {
      if (!newValue || `${newValue._id}` === `${oldValue._id}`) return;

      // Narrative player needs to reset when appropriate for visual
      // continuity, but this bypasses the normal router state machine.
      // There is a special case on the last team decision of the game
      // due to completed team decisions creating a stub of the next
      // team decision (on the back end). This happens for all but the
      // last team decision of the game.
      const shouldContinueNarratives =
        this.individualDecisionFromLastTeamDecision ||
        this.finalTeamDecisionComplete;

      if (shouldContinueNarratives) {
        this.resetNarrativePlayer();
      }
    },
    narratives(newValue, oldValue) {
      // only reset if there's actually a narrative and
      // there's evidence it's different than the previous narrative
      if (newValue && newValue.length > 0
        && (!oldValue
          || newValue.length !== oldValue.length
          || newValue[0].type !== oldValue[0].type
          || newValue[0].text !== oldValue[0].text)) {
        this.init();
      }
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativePlayer.vue